
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const NavLogo = () => {
  const isMobile = useIsMobile();
  
  return (
    <Link to="/" className="flex items-center group">
      <div className="bg-gradient-to-r from-primary to-primary/80 text-white rounded-xl p-2 mr-2 md:mr-3 shadow-sm group-hover:shadow-md transition-all">
        <FileText className="h-4 w-4 md:h-5 md:w-5" />
      </div>
      <div className="flex flex-col items-start">
        <span className="font-bold text-lg md:text-xl tracking-tight">PaperVerse</span>
        {!isMobile && (
          <span className="text-xs text-muted-foreground -mt-1">Reimagining Research</span>
        )}
      </div>
    </Link>
  );
};

export default NavLogo;
